import { Injectable } from '@angular/core';
import Chart from 'chart.js/auto';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly STORAGE_KEY = 'themeColor';
  private readonly DEFAULT_COLOR = '#005ec9';

  private readonly DISPLAY_MODE_KEY = 'displayMode';
  private readonly DEFAULT_DISPLAY_MODE = 'Light mode';

  initTheme(): void {
    const savedColor = this.getThemeColor();
    this.applyThemeColor(savedColor);
    this.initDisplayMode();
  }

  getThemeColor(): string {
    return localStorage.getItem(this.STORAGE_KEY) || this.DEFAULT_COLOR;
  }

  setThemeColor(color: string): void {
    if (!color) return;
    localStorage.setItem(this.STORAGE_KEY, color);
    this.applyThemeColor(color);
  }

  private applyThemeColor(color: string): void {
    document.documentElement.style.setProperty('--primary-theme-color', color);
  }

  initDisplayMode(): void {
    let savedMode = localStorage.getItem(this.DISPLAY_MODE_KEY);
    if (!savedMode) {
      savedMode = this.DEFAULT_DISPLAY_MODE;
      localStorage.setItem(this.DISPLAY_MODE_KEY, savedMode);
    }
    this.applyDisplayMode(savedMode);
  }

  getDisplayMode(): string {
    return localStorage.getItem(this.DISPLAY_MODE_KEY) || this.DEFAULT_DISPLAY_MODE;
  }

  setDisplayMode(mode: string): void {
    if (!mode) return;
    localStorage.setItem(this.DISPLAY_MODE_KEY, mode);
    this.applyDisplayMode(mode);
  }

  resetToDefaultMode(): void {
    localStorage.setItem(this.DISPLAY_MODE_KEY, this.DEFAULT_DISPLAY_MODE);
    this.applyDisplayMode(this.DEFAULT_DISPLAY_MODE);
  }

  private applyDisplayMode(mode: string): void {
    const themeValue = mode === 'Dark mode' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', themeValue);
    if (document.body) {
      document.body.setAttribute('data-theme', themeValue);
    }
    try {
      if (Chart && Chart.defaults) {
        Chart.defaults.color = themeValue === 'dark' ? '#cbd5e1' : '#666666';
      }
    } catch (e) {
      // Ignore if Chart is not loaded yet
    }
  }
}


